import React, { useContext, useState, useEffect } from "react";
import { Box, TextField, CircularProgress } from "@mui/material";
import { pathJoinUrl } from "@smfa/utils/src";
import { AppContext } from "../context";
import { getMeetBannerData, updateBannerData } from "../actions/meet.actions";
import FileUploadArea from "./common/FileUploadArea";

const Meeting = () => {
  const { storage } = useContext(AppContext);
  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  var addAboutBanner_default = {
    meeting_banner_section_id: 0,

    banner_image: "",
    banner_image_name: "",
    banner_image_error: false,
    banner_image_mob: "",
    banner_image_mob_name: "",
    banner_image_mob_error: false,
    banner_title: "",
    banner_title_maxlenth: 10,
    banner_title_error: false,
  };
  const [addAboutBanner, setAboutBanner] = useState(addAboutBanner_default);

  const [deskimage, setDeskImage] = useState("");
  const onImageChange = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.files[0]) {
      setDeskImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image = event.target.files[0];
      custInfo.banner_image_name = event.target.files[0].name;
      custInfo.banner_image_error = false;
      setAboutBanner(custInfo);
    }
  };

  const [mobimage, setMobImage] = useState("");
  const onMobImageChange = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.files && event.target.files[0]) {
      setMobImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image_mob = event.target.files[0];
      custInfo.banner_image_mob_name = event.target.files[0].name;
      custInfo.banner_image_mob_error = false;
      setAboutBanner(custInfo);
    }
  };

  useEffect(() => {
    getMeetBannerData().then((res) => {
      var locInfo = { ...addAboutBanner };
      if (res.data.status === true) {
        locInfo.meeting_banner_section_id =
          res.data.data.meeting_banner_section_id;

        locInfo.banner_title = res.data.data.banner_title;

        locInfo.banner_image_name = res.data.data.banner_image;
        locInfo.banner_image_mob_name = res.data.data.banner_image_mob;
        setAboutBanner(locInfo);
        if (res.data.data.banner_image !== null) {
          setDeskImage(
            pathJoinUrl(storage[0].imageEndUrl, res.data.data.banner_image),
          );
        }
        if (res.data.data.banner_image_mob !== null) {
          setMobImage(
            pathJoinUrl(storage[0].imageEndUrl, res.data.data.banner_image_mob),
          );
        }
      } else {
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addAboutBannerInfo = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.name === "banner_title") {
      if (event.target.value.length <= addAboutBanner.banner_title_maxlenth) {
        custInfo.banner_title = event.target.value;
        custInfo.banner_title_error = false;
      }
    }

    setAboutBanner(custInfo);
  };

  const submitLocation = () => {
    // return false;
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    var custInfo = { ...addAboutBanner };

    if (addAboutBanner.banner_title === "") {
      document.getElementById("banner_title").focus();
      custInfo.banner_title_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setAboutBanner(custInfo);

      setLoader(false);
      return false;
    }

    const formData = new FormData();
    formData.append(
      "meeting_banner_section_id",
      addAboutBanner.meeting_banner_section_id,
    );
    formData.append("banner_image_mob", addAboutBanner.banner_image_mob);
    formData.append("banner_image", addAboutBanner.banner_image);
    formData.append("banner_title", addAboutBanner.banner_title);

    if (addAboutBanner.meeting_banner_section_id === 0) {
      updateBannerData(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg("Join  Added Successfully!");
            setLoader(false);
            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setAboutBanner(addAboutBanner_default);
            setErrorMsg(res1.data.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          setAboutBanner(addAboutBanner_default);
          setLoader(false);
          setErrorMsg("Something went wrong, please try again!");
        });
    } else {
      updateBannerData(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg("Banner Updated Successfully!");
            setLoader(false);

            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setErrorMsg("Something went wrong, please try again!");
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
          setErrorMsg("Something went wrong, please try again!");
        });
    }
  };

  return (
    <>
      <div className="content">
        <div className="body-inner-sec">
          <div className="container-fluid">
            <div className="banner-inner-bdy-sec tab-sec-smfa">
              <div className="row">
                <div className="col-md-4">
                  <div className="about-banner-sec">
                    <div className="form-secs inner-form-secs vali-forms">
                      <Box
                        component="form"
                        sx={{
                          "& > :not(style)": { m: 1, width: "25ch" },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <TextField
                          id="banner_title"
                          label="Title"
                          variant="standard"
                          onChange={addAboutBannerInfo}
                          name="banner_title"
                          value={addAboutBanner.banner_title}
                          error={addAboutBanner.banner_title_error}
                          helperText={` ${addAboutBanner.banner_title_error === true ? "Please enter Title!" : ""}`}
                        />
                        <div className="charcter-sec">
                          {addAboutBanner.banner_title_maxlenth -
                            addAboutBanner.banner_title.length ===
                          0 ? (
                            <>
                              <span
                                className="char-limit"
                                style={{ color: "#FF0000" }}
                              >
                                Max Character Limit reached{" "}
                              </span>
                            </>
                          ) : (
                            <>
                              <p className="max-charact-sec">
                                Max Characters:&nbsp;
                                {addAboutBanner.banner_title_maxlenth -
                                  addAboutBanner.banner_title.length}
                              </p>
                            </>
                          )}
                        </div>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-5 banner-uplod-secs involved-sec">
                  <FileUploadArea
                    title="Add Banner Image For Desktop"
                    description={
                      <>
                        Best image Resolution: 1920px X 836px
                        <br />
                        Supported files types: JPG, JPEG & PNG
                      </>
                    }
                    previewUrl={deskimage}
                    fileName={addAboutBanner.banner_image_name}
                    onChange={onImageChange}
                    deleteRequest={{
                      resource: "meeting-banner",
                      id: addAboutBanner.meeting_banner_section_id,
                      field: "banner_image",
                    }}
                    onRemove={() => {
                      setDeskImage("");
                      setAboutBanner((previous) => ({
                        ...previous,
                        banner_image: "",
                        banner_image_name: "",
                      }));
                    }}
                    accept=".png,.jpg,.jpeg"
                  />
                </div>
                <div className="col-md-5 banner-uplod-secs involved-sec">
                  <FileUploadArea
                    title="Add Banner Image For Mobile"
                    description={
                      <>
                        Best image Resolution: 400px X 350px
                        <br />
                        Supported files types: JPG, JPEG & PNG
                      </>
                    }
                    previewUrl={mobimage}
                    fileName={addAboutBanner.banner_image_mob_name}
                    onChange={onMobImageChange}
                    deleteRequest={{
                      resource: "meeting-banner",
                      id: addAboutBanner.meeting_banner_section_id,
                      field: "banner_image_mob",
                    }}
                    onRemove={() => {
                      setMobImage("");
                      setAboutBanner((previous) => ({
                        ...previous,
                        banner_image_mob: "",
                        banner_image_mob_name: "",
                      }));
                    }}
                    accept=".png,.jpg,.jpeg"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="button-sec mision-btn">
                    <button
                      type="button "
                      className="btn btn-login btn-update"
                      onClick={(e) => {
                        submitLocation();
                        e.preventDefault();
                      }}
                    >
                      Update
                      {loader === true ? (
                        <CircularProgress
                          style={{
                            width: "15px",
                            height: "15px",
                            marginLeft: "5px",
                            color: "white",
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </button>
                    <div
                      className="validate-sec"
                      style={{ marginBottom: "15px" }}
                    >
                      {successMsg !== "" ? (
                        <div className="">
                          <p className="succ-msg">{successMsg}</p>
                        </div>
                      ) : (
                        <div className="">
                          <p
                            className="succ-msg"
                            style={{ visibility: "hidden" }}
                          >
                            Banner Updated Successfully!
                          </p>
                        </div>
                      )}
                      {errorMsg !== "" ? (
                        <div className="">
                          <p className="error-msg">{errorMsg}</p>
                        </div>
                      ) : (
                        <div className="">
                          <p
                            className="error-msg"
                            style={{ visibility: "hidden" }}
                          >
                            Something went wrong, please try again!
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Meeting;
